/*
  Some fields share the same logic, for this we put that logic here
*/
import {
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  REFERENCES_SECTION,
  COMPLETION_REVIEW,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  EXPEDITED_MOBILE,
  EXPEDITED_FIXED,
  FIXED,
  IMPACT_LEVEL_1,
  IMPACT_LEVEL_2,
  EMERGENCY_MOBILE,
  EMERGENCY_FIXED,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  selectNetworkParamsId,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one-constants';
import {
  impactId,
  selectChangeSlaId,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two-constants';
import { STATUS_REASON } from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';
import { pou } from './references-section/pou';


const getIsOlaCrq = (formData) => {
  const otherLineOperator = formData && formData.otherLineOperator ? formData.otherLineOperator : 'No';
  let isOloNetwork = false;
  const changeTypeSection = formData && formData.dataByFormSectionId[CHANGE_TYPE];
  const selectedNetworkFieldData = changeTypeSection ? changeTypeSection.dataByFieldId[selectNetworkParamsId] : null;
  if ((selectedNetworkFieldData && selectedNetworkFieldData.value[0] === 'fixedOlo') || otherLineOperator === 'Yes') {
    isOloNetwork = true;
  }
  return isOloNetwork;
};

// ICM true flag
const getIsInternationalCrq = (formData) => {
  let isInternationalNetwork = false;
  const changeTypeSection = formData && formData.dataByFormSectionId[CHANGE_TYPE];
  const selectedNetworkFieldData = changeTypeSection ? changeTypeSection.dataByFieldId[selectNetworkParamsId] : null;
  if ((selectedNetworkFieldData && selectedNetworkFieldData.value[0] === 'fixedInternational')) {
    isInternationalNetwork = true;
  }
  return isInternationalNetwork;
};

const isCrqExpedited = (formData) => {
  try {
    // const isOloCrq = getIsOlaCrq(formData);
    const changeDetails = 'CHANGE_DETAILS';
    const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
    const isOloCrq = getIsOlaCrq(formData) || isOloByService;
    let slaValue = [];
    if (isOloCrq) {
      slaValue = formData.dataByFormSectionId[CHANGE_TYPE].dataByFieldId[selectChangeSlaId].value;
    }
    else if (formData && formData.dataByFormSectionId[CHANGE_QUESTIONS]) {
      slaValue = formData.dataByFormSectionId[CHANGE_QUESTIONS].dataByFieldId[selectChangeSlaId].value;
    }
    // const slaValue = formData.dataByFormSectionId[CHANGE_QUESTIONS].dataByFieldId[selectChangeSlaId].value;
    const isExpedited = (slaValue && slaValue.includes(EXPEDITED_MOBILE)) || (slaValue && slaValue.includes(EXPEDITED_FIXED));
    return isExpedited;
  }
  catch (codeError) {
    console.warn('CANNOT DETERMINE IF CRQ IS EXPEDITED');
    console.error(codeError);
    // return false to state the form is not expedited
    return false;
  }
};

const isCrqEmergency = (formData) => {
  try {
    const changeDetails = 'CHANGE_DETAILS';
    const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
    const isOloCrq = getIsOlaCrq(formData) || isOloByService;
    let slaValue = [];
    if (isOloCrq) {
      slaValue = formData.dataByFormSectionId[CHANGE_TYPE].dataByFieldId[selectChangeSlaId].value;
    }
    else if (formData && formData.dataByFormSectionId[CHANGE_QUESTIONS]) {
      slaValue = formData.dataByFormSectionId[CHANGE_QUESTIONS].dataByFieldId[selectChangeSlaId].value;
    }
    // const slaValue = formData.dataByFormSectionId[CHANGE_QUESTIONS].dataByFieldId[selectChangeSlaId].value;
    const isEmergency = (slaValue && slaValue.includes(EMERGENCY_MOBILE)) || (slaValue && slaValue.includes(EMERGENCY_FIXED));
    return isEmergency;
  }
  catch (codeError) {
    console.warn('CANNOT DETERMINE IF CRQ IS EMERGENCY');
    console.error(codeError);
    // return false to state the form is not expedited
    return false;
  }
};


// if values is an array, return
// a single value if the array is of length 1
// an array if more than one entry
// null if no entry
const arrayValueOrNull = (values) => {
  if (!values || values.length === 0) { return null; }
  if (Array.isArray(values) && values.length === 1) { return values[0]; }
  return values;
};

const getFormDataField = ({
  formData,
  sectionId,
  fieldId,
}) => {

  if (sectionId === CHANGE_TYPE) {
    const changeTypeSection = formData.dataByFormSectionId[CHANGE_TYPE];
    const selectedNetworkFieldData = changeTypeSection ? changeTypeSection.dataByFieldId[selectNetworkParamsId] : null;
    return selectedNetworkFieldData;
  }
  const sectionData = formData ? formData.dataByFormSectionId[sectionId] : null;
  return sectionData ? sectionData.dataByFieldId[fieldId] : null;
};

const getFormDataFieldValue = (params) => {
  const fieldData = getFormDataField(params);
  return fieldData ? fieldData.value : null;
};

const getFormDataFieldDisplayValues = (params) => {
  const fieldData = getFormDataField(params);
  return fieldData ? fieldData.displayValues : null;
};

const getTimingValue = (crqData) => {
  const timingSection = crqData.dataByFormSectionId.CHANGE_TYPE;
  const timing = timingSection ? timingSection.dataByFieldId.timing.value[0] : null;
  return timing;
};
// method to retrieve a value for the api parameter based on the redux data
// parameters:
//   formData - redux data for the form
//   sectionId - E.G 'CHANGE_TYPE'
//   fieldId - E.G 'timing'
//   asNumber - if true, the value should be parsed as a number
const getFieldValueForParameters = ({
  formData,
  sectionId,
  fieldId,
  asNumber,
  asCommaSeparatedString,
  asArray,
}) => {
  const fieldValue = getFormDataFieldValue({ formData, sectionId, fieldId });
  const values = fieldValue ? arrayValueOrNull(fieldValue) : null;
  // format data to endpoint specs
  if (values && asNumber) {
    return Number(values);
  }

  // if it's meant to be a comma separated string, use the underlying fieldValue array
  if (fieldValue && asCommaSeparatedString) {
    return fieldValue.join(', ');
  }

  if (fieldValue && asArray) {
    return fieldValue;
  }
  return values;
};

// util for retrieving the currently selected network type
// from the form data
// returns 'mobile', 'fixed' or undefined
const currentSelectedNetwork = (formData) => {
  const changeTypeSection = formData.dataByFormSectionId[CHANGE_TYPE];
  const selectedNetworkFieldData = changeTypeSection ? changeTypeSection.dataByFieldId[selectNetworkParamsId] : null;
  let selectedNetwork = '';
  if (selectedNetworkFieldData && selectedNetworkFieldData.value[0] === 'fixedOlo') {
    selectedNetwork = 'fixed';
  }
  else if (selectedNetworkFieldData && selectedNetworkFieldData.value[0] === 'fixedInternational') {
    selectedNetwork = 'fixed';
  }
  else {
    selectedNetwork = selectedNetworkFieldData ? selectedNetworkFieldData.value[0] : undefined;
  }
  return selectedNetwork;
};


// Retrieve the current user role for the selected network type (e.g 'mobile' or 'fixed')
// This is used throughout the form for showing or hiding certain fields
const userRoleForSelectedNetwork = (formData, userRoles) => {
  let selectedNetwork = currentSelectedNetwork(formData);
  selectedNetwork = ((selectedNetwork === 'fixedOlo') || (selectedNetwork === 'fixedInternational')) ? 'fixed' : selectedNetwork;
  return userRoles ? userRoles[selectedNetwork] : undefined;
};

const getImpactLevel = (formData) => {
  try {
    return formData.dataByFormSectionId[CHANGE_QUESTIONS].dataByFieldId[impactId].value;
  }
  catch (codeError) {
    console.warn(`CANNOT GET VALUE FOR impact ${impactId}`);
    console.error(codeError);
    // return false to state the form is not expedited
    return null;
  }
};


const getRiskValue = (formData) => {
  // we shouldn't need a try catch here as the only thing that can fall over is if formData isn't defined, but
  // that'd be a much bigger problem that would fall over before we get here
  const {
    riskValue,
  } = formData;

  // technically risk value will never === 0 but if they want a risk value 0 in the future, we should count it as true!
  if (riskValue === 0 || !riskValue) {
    console.warn('RISK VALUE IS NOT DEFINED');
    return null;
  }

  return riskValue;
};



const getRemedyIdForNetwork = (formData, remedyIds) => {
  const selectedNetwork = currentSelectedNetwork(formData);
  return remedyIds ? remedyIds[selectedNetwork] : undefined;
};


const getPouId = (formData) => {
  const sectionId = REFERENCES_SECTION;
  const fieldId = pou.id;
  return getFormDataFieldValue({
    formData,
    sectionId,
    fieldId,
  });
};

// method to determing whether a CRQ should have a generated POU on the server
// FIXED CRQs with an impact of 1 or 2 will have a generated POUs
const crqRequiresPou = (
  formData,
) => {
  if (!formData) return false;
  const network = currentSelectedNetwork(formData);
  if (network !== FIXED) return false;

  const impactLevelValue = getImpactLevel(formData);
  if (impactLevelValue === IMPACT_LEVEL_1 || impactLevelValue === IMPACT_LEVEL_2) {
    return true;
  }
  return false;
};

const ChangeAnalyst = (crqData) => (crqData.assignToMeFlag ? crqData.assignToMeFlag : null);
const GetStatusReason = (crqData) => {
  const CompletionstatusReason = crqData.dataByFormSectionId[COMPLETION_REVIEW];
  const statusReason = CompletionstatusReason ? CompletionstatusReason.dataByFieldId[STATUS_REASON].value : null;
  return statusReason;
};
export {
  isCrqExpedited,
  isCrqEmergency,
  currentSelectedNetwork,
  getIsOlaCrq,
  userRoleForSelectedNetwork,
  getImpactLevel,
  getRiskValue,
  arrayValueOrNull,
  getFormDataFieldValue,
  getFormDataFieldDisplayValues,
  getFieldValueForParameters,
  getRemedyIdForNetwork,
  getPouId,
  crqRequiresPou,
  getTimingValue,
  ChangeAnalyst,
  GetStatusReason,
  getIsInternationalCrq,
};
